import { PropsWithChildren, useState } from "react";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";

export interface ToggledContainerProps extends PropsWithChildren {
    label: string,
}

export function ToggledContainer({
    label,
    children
}: ToggledContainerProps) {
    const [toggled, setToggled] = useState<boolean>(false)
    return <div className="d-flex flex-column gap-4">
        <div className="d-flex align-items-center justify-content-between cursor-pointer"
            onClick={() => setToggled((state) => !state)}
        >
            <p className="form-label mb-0 fs-6 fw-bolder text-dark">{label}</p>
            <span>
                {toggled ? <ChevronUp /> : <ChevronDown />}
            </span>
        </div>
        {toggled ? <div className="p-4 rounded bg-light">
            {children}
        </div> : null}
    </div>
}